import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=2228bc22&scoped=true&"
import script from "./editCompany.vue?vue&type=script&lang=js&"
export * from "./editCompany.vue?vue&type=script&lang=js&"
import style0 from "./editCompany.vue?vue&type=style&index=0&id=2228bc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228bc22",
  null
  
)

export default component.exports